import React, { Component } from 'react';
import "./Resume.css";

class Bootcamp extends Component {
    render() {
        return (
            <div className="Bootcamp">
                        <h2 className="text-center section-heading">Georgia Institute of Technology 11/17 - 5/18</h2>
                        <hr/>
                        <p><strong>Overall Grade Average: 92.9</strong></p>
                        <p>Georgia Tech Coding Program - Full Stack Web Development</p>
                        </div>    
        );
    }
} 

export default Bootcamp;





// WEBPACK FOOTER //
// ./src/components/Resume/Bootcamp.js